import { render } from "./ProjectsArchive.vue?vue&type=template&id=442451aa"
import script from "./ProjectsArchive.vue?vue&type=script&lang=js"
export * from "./ProjectsArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__